import { getRequest } from "lib/core/apiClient";
import { getBillingDetails } from "lib/utils/checkout";
import { BillingType } from "lib/types/checkout";

export interface MerchantAndCheckoutDetails {
  checkout: {
    checkoutResponse: any;
    brandUrl: string;
    analyticsMeta: any;
    redirectUrl: string;
    checkoutToken: string;
    isCheckoutC2P: boolean;
    sessionId: string;
    parsedBilling: BillingType;
    longSessionId: string;
    thirdPartyAnalyticsData: any;
    clientMetadata: any;
    checkoutChannel: any;
    segmentId: string;
  };
}

export async function fetchMerchantAndCheckoutDetails(
  checkoutId: string,
): Promise<MerchantAndCheckoutDetails> {
  const checkoutResponse = await getRequest(`/checkout/v1/checkout/${checkoutId}?include=token`);

  const redirectUrl =
    checkoutResponse?.token?.data?.redirect_url ?? checkoutResponse?.token?.data?.back_url ?? "";

  const parsedBilling: BillingType = getBillingDetails(checkoutResponse?.pricing) ?? {
    total_payable: 0,
    sub_total: 0,
    total: 0,
    tax: 0,
    rewards: 0,
    discount: 0,
    shipping: 0,
    cod: 0,
    cod_enabled: false,
    taxes_included: true,
    serviceable: true,
    prepaid_total: 0,
    prepaid_discount: 0,
    original_sub_total: 0,
    addon_total: 0,
    gift_card: 0,
  };

  return {
    checkout: {
      checkoutResponse,
      brandUrl: checkoutResponse?.token?.data?.origin_url ?? "",
      analyticsMeta: checkoutResponse?.metadata?.analytics ?? {},
      redirectUrl,
      checkoutToken: checkoutResponse?.checkout_token_id ?? "",
      isCheckoutC2P: checkoutResponse?.metadata?.c2p?.enabled ?? false,
      sessionId: checkoutResponse?.token?.sf_session_id ?? "",
      parsedBilling,
      longSessionId: checkoutResponse?.metadata?.long_session_id ?? "",
      thirdPartyAnalyticsData: checkoutResponse?.metadata?.analytics ?? {},
      clientMetadata: checkoutResponse?.metadata?.client_meta ?? {},
      checkoutChannel: checkoutResponse?.metadata?.application_id ?? "",
      segmentId: checkoutResponse?.segment_id ?? "",
    },
  };
}
